export default "__VITE_ASSET__73ca5a35__"